define('controllers/submit',[
	'jquery',
	'modules/page',
	'widgets/pages',
	'widgets/date',
	'widgets/age',
	'widgets/time',
	'widgets/hint',
	'widgets/select',
	'widgets/files',
	'lib/jquery.form-validator',
	'lib/bootstrap-datetimepicker',
	// 'lib/moment',
], function ($, page) {

	var submit = {

		id: 'submit',
		ready: false,
		enabled: null,

		setup: function () {

			if (this.ready) return this;

			this.update();

			this.ready = true;
			return this;

		},

		enable: function () {

			if (this.enabled) return this;

			$.subscribe({
			});
			this.$el.addClass('enabled');

			this.$date = this.$form.find('.date input').datetimepicker({
				format: 'DD-MM-YYYY'
			});
			// this.$date.data('DateTimePicker').show();

			this.enabled = true;
			return this;

		},

		disable: function () {

			if (!this.enabled) return this;

			this.$el.off('.' + this.id);
			$.unsubscribe('.' + this.id);

			this.$el.removeClass('enabled');

			this.enabled = false;
			return this;

		},

		update: function () {

			var $el = $('#' + this.id);

			if (this.$el && this.$el[0] == $el[0])
				return;

			this.$el = $el;
			this.$form = this.$el.find('form');

			$.validate({
				form : '#submit form',
				onError: $.proxy(this, 'onError'),
				borderColorOnError : '',
				validateOnBlur: false
			});

		},

		onError: function () {

			var $error = this.$form.find('.has-error:first'),
				$wrap = $error.closest('.wrap'),
				top = ($wrap.height() - this.$el.find('.wrap:first').height()) + $error.position().top;

			page.$win.scrollTop(top);

		}

	};

	return submit;

});
